<template>
  <div id="app">
    <div class="wx-pages">
      <v-touch v-on:swipeleft="swiperleft" :swipe-options="{direction: 'horizontal'}" class="wrapper">
        <transition :name="transitionName">
          <!-- 缓存数据 <router-view> -->
          <keep-alive>
            <router-view class="page"></router-view>
          </keep-alive>
        </transition>
      </v-touch>
    </div>

  </div>
</template>

<script>

import jump from "./common/jump";

export default {
  name: 'app',
  data(){
    return {
      transitionName:"slide-left",
      show:false
    }
  },

  mounted() {
    jump.$on('back',(data)=> {
      this.back(data);
    })
    jump.$on('goNext',(data)=> {
      this.goNext(data);
    })
  },

  /* 页面切换动画 */
  watch: {
  },
  methods:{
    swiperleft:function (){
      this.transitionName = "aaa"
    },
    back(){
      this.transitionName = "slide-right";
    },
    goNext(){
      this.transitionName = "slide-left";

    }
  }
}
</script>

<style>
#app {
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding:0;
  margin:0
}

/* 页面切换动画 */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  /* will-change属性可以提前通知浏览器我们要对元素做什么动画，这样浏览器可以提前准备合适的优化设置 */
  will-change: transform;
  transition: all ease 0.4s;
  -webkit-transition: all ease 0.4s;
  position: absolute;
  width: 100%;
  left: 0;
}
.slide-right-enter {
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}
.slide-right-leave-active {
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}
.slide-left-enter {
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}
.slide-left-leave-active {
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}

</style>
